import { StaticSourceModel, LinkedSourceModel } from '../models';

export default class InstanceUtils {
    static isStaticSource(value: unknown): value is StaticSourceModel {
        return value instanceof StaticSourceModel;
    }

    static isLinkedSource(value: unknown): value is LinkedSourceModel {
        return value instanceof LinkedSourceModel;
    }
}
